import { ActionContext } from "vuex";
import { PlanTrailState } from "../PlanTrailModule";
import { RootState } from "../../store";
import { MarkerFeature } from "../../../../../utils/models/MarkerFeature";
import { LineStringFeature } from "../../../../../utils/models/LineStringFeature";
import mapboxgl from "mapbox-gl";

// Minimum length we consider a valid segment; used to avoid zero-length linestrings
export const MIN_SEGMENT_DISTANCE_METERS = 1;

// Common action context type
export type PlanTrailActionContext = ActionContext<PlanTrailState, RootState>;

// Common parameter types
export interface MarkerMapData {
  marker: MarkerFeature;
  id: string;
  isFirst: boolean;
}

export interface LineStringMapData {
  lineStringFeature: LineStringFeature;
  id: number;
}

export interface RouteMarkerData {
  marker: MarkerFeature;
  routeId: string;
  markerIndex: number;
  isActive: boolean;
}

export interface RouteLineStringData {
  lineStringFeature: LineStringFeature;
  routeId: string;
  lineIndex: number;
  isActive: boolean;
}

export interface InsertMarkerData {
  linestringFeature: any;
  markerFeature: any;
}

export interface InsertPointData {
  point: [number, number];
  routeId: string;
  insertIndex: number;
  segmentIndex?: number;
}

export interface FileUploadData {
  files: File[];
  ids: string[];
}

export interface ImageDestroyData {
  id: string;
  file: File;
}

// Map utilities
export function getMap(): mapboxgl.Map {
  if (!window.map) {
    throw new Error("Map not initialized");
  }
  return window.map;
}

export function getLayerRegistry(): any {
  if (!window.layerRegistry) {
    throw new Error("Layer registry not initialized");
  }
  return window.layerRegistry;
}

// Layer utilities
export function safeRemoveLayer(layerId: string): void {
  const map = getMap();
  const layerRegistry = getLayerRegistry();
  
  if (map.getLayer(layerId)) {
    try {
      layerRegistry.removeLayer(layerId);
    } catch (e) {
      // Fallback to direct removal
      map.removeLayer(layerId);
      if (map.getSource(layerId)) {
        map.removeSource(layerId);
      }
    }
  }
}

export function layerExists(layerId: string): boolean {
  const map = getMap();
  return !!map.getLayer(layerId);
}
